














































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { aRefundDetail } from '@/utils/api';
@Component
export default class aRefund extends Vue {
  @Prop(String) nowCode: String;
  @Prop(Boolean) drawer: Boolean;
  @Watch('drawer', { immediate: true, deep: true })
  drawerChangeHandler(val) {
    if (val) {
      this.aRefundDetail({ aftersaleOrderCode: this.nowCode });
    }
  }
  labelPosition: string = 'right';
  aftersaleInfo: object = {};
  // 获取退款详情
  aRefundDetail(info) {
    aRefundDetail(info)
      .then(res => {
        this.aftersaleInfo = res;
      })
      .catch(err => {
        console.log(err);
      });
  }
  created() {}
}
